import http from './http';

class HeadquartersService {
    getHeadquarters() {
        return http.get('/headquarters');
    }

    createHeadquarter(payload) {
        return http.post('/headquarters', payload);
    }

    editHeadquarter(id, payload) {
        return http.put(`/headquarters/${id}`, payload);
    }

    deleteHeadquarter(id) {
        return http.delete(`/headquarters/${id}`);
    }
}

export default new HeadquartersService(); 
